
import Swiper from 'swiper'
import { Pagination, Grid } from 'swiper/modules'
import 'swiper/swiper-bundle.css'

const mapInstitutions = () => {

    const coordsLux = {
        northWest: { long: 50.183056, lat: 5.718333 },
        southEast: { long: 49.401667, lat: 6.550833 }
    }

    

    setTimeout(() => {
        const slider = new Swiper(document.querySelector('.swiper-institutions'), {
            modules: [Grid, Pagination],
            spaceBetween: 40,

            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints :{
                100: {
                    slidesPerView: 2,
                    grid: {
                        rows: 1,
                        fill: 'column'
                    },
                },
                819: {
                    slidesPerView: 2,
                    grid: {
                        rows: 1,
                        fill: 'column'
                    },
                },
                1024 : {
                    slidesPerView: 1,
                    grid: {
                        rows: 3,
                    },
                }
            }
        })
    }, 200)

    document.querySelectorAll('.ia-block-map-instritutions__listing-institutions__item').forEach(item => {
        if (item.dataset?.address !== '') {
            //create pin
            const itemCategory = item.querySelector('.item-category').dataset.category
            const adress = {}
            adress.long = item.dataset.address.split(',')[0]
            adress.lat = item.dataset.address.split(',')[1]
            
            const pointLatPosition = 100 * ((coordsLux.northWest.lat - adress.lat) / (coordsLux.northWest.lat - coordsLux.southEast.lat))
            const pointLongPosition = 100 * ((coordsLux.northWest.long - adress.long) / (coordsLux.northWest.long - coordsLux.southEast.long))

            const coordPoints = {left: Math.round(pointLatPosition), top: Math.round(pointLongPosition)}
            
            const pin = document.createElement('a')
            pin.setAttribute('class',`map-pin ${itemCategory}`)
            pin.setAttribute('data-address', item.dataset.address)
            if (item.hasAttribute('data-filter')) {
                pin.setAttribute('data-filter', item.dataset.filter)
                pin.setAttribute('data-filter-main', item.dataset.filterMainCategory)
            }

            pin.style.left = coordPoints.left+'%'
            pin.style.top = coordPoints.top+'%'
            // pin.style.transform = `rotate(${Math.floor(Math.random() * 61) - 30}deg)`

            let checkIfPinIsAlreadySet = []
            if (!!document.querySelector('.map-pin')) {
                checkIfPinIsAlreadySet = Array.from(document.querySelectorAll('.map-pin')).filter(item => item.dataset.address === pin.dataset.address && item.dataset.filter === pin.dataset.filterMain)
            }

            const sameAddressPins = Array.from(document.querySelectorAll('.map-pin')).filter(item => item.dataset.address === pin.dataset.address)
            sameAddressPins.forEach((pinWithSameAddress, index) => {
                pinWithSameAddress.style.left = coordPoints.left+(index*2)+'%'
            })
            if (!checkIfPinIsAlreadySet.length > 0) {
                document.querySelector('.ia-block-map-instritutions__map__content').append(pin)
            }

            // filter address action
            pin.addEventListener('click', function(e){
                e.preventDefault()
                let isHandicaporSenior = false
                let arrayCatSplit
                if(e.target.hasAttribute('data-filter')) {
                    arrayCatSplit = e.target.dataset.filter.split(',')
                } else {
                    isHandicaporSenior = true
                }
                    
                    hideShowItem(document.querySelectorAll('.ia-block-map-instritutions__listing-institutions__item'), isHandicaporSenior? null: arrayCatSplit[0], e.target.dataset.address)
                    
                    document.querySelectorAll('.map-pin').forEach(pin => pin.classList.add('hide'))
                    pin.classList.remove('hide')
                    updateMap()

            })
        }
    })
    
    // filter categories action
    if (!!document.querySelector('.ia-block-map-instritutions__filter__item ')) {
        document.querySelectorAll('.ia-block-map-instritutions__filter__item a').forEach(item => {
            item.addEventListener('click', function(e){
                e.preventDefault()
                
                let hash
                if(e.target.hash === '') {
                    hash = null
                } else {
                    hash = e.target.hash.replace('#', '')
                }
                hideShowItem(document.querySelectorAll('.ia-block-map-instritutions__listing-institutions__item'), hash)
                hideShowItem(document.querySelectorAll('.map-pin'), hash, null)
                updateMap(item)
            })
        });
    }
    
}

function hideShowItem(items, catClicked=null, adressFilter=null) {
    const swiperr = document.querySelector('.swiper-institutions').swiper
    items.forEach(item => item.classList.remove('hide'))
    // Array.from(document.querySelectorAll('.map-pin')).map(pin => pin.classList = [...['map-pin']])
    Array.from(document.querySelectorAll('.map-pin')).map(pin =>  removeClassByPrefix(pin, 'has-'))
    document.querySelectorAll('.ia-block-map-instritutions__listing-institutions__item').forEach(item => item.classList.remove('swiper-slide'))
    if(!!document.querySelector('.ia-block-map-instritutions__filter__item')) {
        if(catClicked === null) {
            document.querySelectorAll('.ia-block-map-instritutions__filter__item a').forEach(link => link.classList.add('active'))
        } else {
            document.querySelectorAll('.ia-block-map-instritutions__filter__item a').forEach(link => link.classList.remove('active'))
        }
    }

    if (catClicked !== null) {
        if(!!document.querySelector('.ia-block-map-instritutions__filter__item')) {
            const inputCategoryClicked = Array.from(document.querySelectorAll('.ia-block-map-instritutions__filter__item a')).filter(link => link.hash === `#${catClicked}`)
            inputCategoryClicked[0].classList.add('active')
        }
        

        Array.from(items).map(item => {
            const itemCat = item.dataset.filter.split(',')

            if (!itemCat.includes(catClicked)) {
                item.classList.add('hide')
            } else {
                if(!!document.querySelector('.ia-block-map-instritutions__filter__item')){
                    const classCatInput = document.querySelector(`.ia-block-map-instritutions__filter__item a[href="#${catClicked}"]`).classList
                const keepOnlyDecorativeClass = Array.from(classCatInput).filter(e => e.includes('has-'))
                item.classList.add(keepOnlyDecorativeClass[0])
                }
                
            }
            return item
        })
    }

    if (adressFilter !== null) {
        Array.from(items).map(item => {
            if (adressFilter !== item.dataset.address) {
                item.classList.add('hide')
            }
            return item
        })
    }

    document.querySelectorAll('.ia-block-map-instritutions__listing-institutions__item:not(.hide)').forEach(item => item.classList.add('swiper-slide'))
    setTimeout(() => {
        swiperr.update()
        const bothDisabledButton = Array.from(document.querySelectorAll('.swiper-button-lock')).filter(input => input.classList.contains('swiper-button-disabled'))
        if(bothDisabledButton.length > 1) {
            document.querySelectorAll('.swiper-button-lock').forEach(input => input.classList.add('hide'))
        } else {
            document.querySelectorAll('.swiper-button-lock').forEach(input => input.classList.remove('hide'))

        }
    }, 100);
}


function removeClassByPrefix(el, pref) {
    el.classList.forEach(e => {
        if(e.startsWith(pref)) {
            el.classList.remove(e)
        }
    })
    return el;
}


function updateMap(item) {
    document.querySelectorAll('.map-pin').forEach(pin => pin.classList.remove('is-selected'))
    document.querySelectorAll('.map-pin:not(.hide)').forEach(pin => {
        // pin.classList.add(item.classList[0])
        pin.classList.add('is-selected')
    })
}

export {mapInstitutions}